module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-01-99e9c452739badf13baed840b74db3ea.svg";